import { createStore } from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import uploading from './modules/uploading';

export default createStore({
  state: {
    triggerLibraryRefresh: false,
    libraryRefreshLoading: false,
    loading: false,
    blockAppLoading: true,
    ldInitialized: false,
    keyboard: {
      open: false,
    },
    user: {
      userId: null,
      totalStorage: null,
      subscriptionType: null,
      subscribed: null,
      searchKey: null,
      viewedOnboarding: null,
    },
    auth: {
      isLoggedIn: false,
      user: null,
      accessToken: null,
      refreshToken: null,
    },
    player: {
      artworkSmUrl: null,
      artworkLgUrl: null,
      playingSong: null,
      playingFile: null,
      paused: true,
      currentTime: null,
      percentComplete: 0,
      volume: 1,
      playingPlaylist: null,
      isPlaylistPlaying: false,
      playlistIndex: null,
      playlistSongs: [],
      duration: null,
    },
    uploadingFile: {
      uploading: false,
      percentage: 0,
      songId: null,
      file: null,
      fileId: null,
    },
  } as any,
  mutations,
  actions,
  getters,
  modules: {
    uploading,
  },
});
